import ImageIcon from '@mui/icons-material/Image';
import { ToggleButton, ToggleButtonProps } from '@mui/material';
import { useTranslate } from 'ra-core';
import { useTiptapEditor } from 'ra-input-rich-text';
import { useState } from 'react';
import { FileManagerModal } from '../FileManagerModalInput';

const ImageFmButton = (props: Omit<ToggleButtonProps, 'value'>) => {
  const translate = useTranslate();
  const editor = useTiptapEditor();
  const [showDialog, setShowDialog] = useState(false);

  const label = translate('ra.tiptap.image', { _: 'Image' });

  const addImage = () => {
    setShowDialog(true);
  }

  const handleSelectClick = (selection: any) => {
    console.log('handleSelectClick', selection);
    setShowDialog(false);
    if (1 === selection.length) {
      (editor.chain().focus() as any).setImage({ src: selection[0].src }).run();
    }
  }

  const handleCloseClick = () => {
    console.log('handleCloseClick');
    setShowDialog(false)
  }

  return editor ? (
    <>
      <ToggleButton
        aria-label={label}
        title={label}
        {...props}
        disabled={!editor?.isEditable}
        value="image"
        onClick={addImage}
      >
        <ImageIcon fontSize="inherit" />
      </ToggleButton>
      <FileManagerModal showDialog={showDialog} handleCloseClick={handleCloseClick} handleSelectClick={handleSelectClick} />
    </>
  ) : null;
};

export default ImageFmButton;
